import type { TConversation } from '@cascade/api-client/conversations';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import * as helpers from '#providers/conversations/Conversations.helpers.ts';

export const useMarkConversationEscalated = () => {
  const queryClient = useQueryClient();

  return useCallback(
    (conversationId: string) => {
      const cachedLists = queryClient.getQueriesData<TConversation[]>({
        queryKey: helpers.conversationsQueryPrefix,
      });

      cachedLists.forEach(([queryKey, cachedConversations]) => {
        if (!cachedConversations) {
          return;
        }

        const isEscalatedExcluded = helpers.isExcludingEscalated(queryKey);
        const updated = helpers.markConversationEscalated(
          cachedConversations,
          conversationId,
          isEscalatedExcluded,
        );

        queryClient.setQueryData(queryKey, updated);
      });
    },
    [queryClient],
  );
};
